import React, { useRef } from "react";
import "./Button2.css";
import { Link } from "react-router-dom";

const Button2 = ({ text, link, onClick }) => {
  const spanRef = useRef(null);
  const buttonRef = useRef(null);

  const handleMouseMove = (e) => {
    const button = buttonRef.current;
    const span = spanRef.current;

    const rect = button.getBoundingClientRect();
    const relX = e.pageX - rect.left - window.scrollX;
    const relY = e.pageY - rect.top - window.scrollY;

    span.style.top = `${relY}px`;
    span.style.left = `${relX}px`;
  };

  if (link) {
    // Normal link button
    return (
      <Link
        ref={buttonRef}
        onMouseEnter={handleMouseMove}
        onMouseLeave={handleMouseMove}
        className="btn-2"
        to={link}
      >
        {text}
        <span ref={spanRef} className="hover-span" />
      </Link>
    );
  }

  // Action button (like opening modal)
  return (
    <button
      ref={buttonRef}
      onClick={onClick}
      onMouseEnter={handleMouseMove}
      onMouseLeave={handleMouseMove}
      className="btn-2"
      type="button"
    >
      {text}
      <span ref={spanRef} className="hover-span" />
    </button>
  );
};

export default Button2;
